import { Camera } from "../Cameras/camera";
import { SceneComponentConstants } from "../sceneComponent";
import { EffectLayer } from "./effectLayer";
import { AbstractScene } from "../abstractScene";
// Adds the parser to the scene parsers.
AbstractScene.AddParser(SceneComponentConstants.NAME_EFFECTLAYER, function (parsedData, scene, container, rootUrl) {
    if (parsedData.effectLayers) {
        if (!container.effectLayers) {
            container.effectLayers = new Array();
        }
        for (var index = 0; index < parsedData.effectLayers.length; index++) {
            var effectLayer = EffectLayer.Parse(parsedData.effectLayers[index], scene, rootUrl);
            container.effectLayers.push(effectLayer);
        }
    }
});
AbstractScene.prototype.removeEffectLayer = function (toRemove) {
    var index = this.effectLayers.indexOf(toRemove);
    if (index !== -1) {
        this.effectLayers.splice(index, 1);
    }
    return index;
};
AbstractScene.prototype.addEffectLayer = function (newEffectLayer) {
    this.effectLayers.push(newEffectLayer);
};
/**
 * Defines the layer scene component responsible to manage any effect layers
 * in a given scene.
 */
var EffectLayerSceneComponent = /** @class */ (function () {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */
    function EffectLayerSceneComponent(scene) {
        /**
         * The component name helpfull to identify the component in the list of scene components.
         */
        this.name = SceneComponentConstants.NAME_EFFECTLAYER;
        this._renderEffects = false;
        this._needStencil = false;
        this._previousStencilState = false;
        this.scene = scene;
        this._engine = scene.getEngine();
        scene.effectLayers = new Array();
    }
    /**
     * Registers the component in a given scene
     */
    EffectLayerSceneComponent.prototype.register = function () {
        this.scene._isReadyForMeshStage.registerStep(SceneComponentConstants.STEP_ISREADYFORMESH_EFFECTLAYER, this, this._isReadyForMesh);
        this.scene._cameraDrawRenderTargetStage.registerStep(SceneComponentConstants.STEP_CAMERADRAWRENDERTARGET_EFFECTLAYER, this, this._renderMainTexture);
        this.scene._beforeCameraDrawStage.registerStep(SceneComponentConstants.STEP_BEFORECAMERADRAW_EFFECTLAYER, this, this._setStencil);
        this.scene._afterRenderingGroupDrawStage.registerStep(SceneComponentConstants.STEP_AFTERRENDERINGGROUPDRAW_EFFECTLAYER_DRAW, this, this._drawRenderingGroup);
        this.scene._afterCameraDrawStage.registerStep(SceneComponentConstants.STEP_AFTERCAMERADRAW_EFFECTLAYER, this, this._setStencilBack);
        this.scene._afterCameraDrawStage.registerStep(SceneComponentConstants.STEP_AFTERCAMERADRAW_EFFECTLAYER_DRAW, this, this._drawCamera);
    };
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */
    EffectLayerSceneComponent.prototype.rebuild = function () {
        var layers = this.scene.effectLayers;
        for (var _i = 0, layers_1 = layers; _i < layers_1.length; _i++) {
            var effectLayer = layers_1[_i];
            effectLayer._rebuild();
        }
    };
    /**
     * Serializes the component data to the specified json object
     * @param serializationObject The object to serialize to
     */
    EffectLayerSceneComponent.prototype.serialize = function (serializationObject) {
        // Effect layers
        serializationObject.effectLayers = [];
        var layers = this.scene.effectLayers;
        for (var _i = 0, layers_2 = layers; _i < layers_2.length; _i++) {
            var effectLayer = layers_2[_i];
            if (effectLayer.serialize) {
                serializationObject.effectLayers.push(effectLayer.serialize());
            }
        }
    };
    /**
     * Adds all the elements from the container to the scene
     * @param container the container holding the elements
     */
    EffectLayerSceneComponent.prototype.addFromContainer = function (container) {
        var _this = this;
        if (!container.effectLayers) {
            return;
        }
        container.effectLayers.forEach(function (o) {
            _this.scene.addEffectLayer(o);
        });
    };
    /**
     * Removes all the elements in the container from the scene
     * @param container contains the elements to remove
     * @param dispose if the removed element should be disposed (default: false)
     */
    EffectLayerSceneComponent.prototype.removeFromContainer = function (container, dispose) {
        var _this = this;
        if (!container.effectLayers) {
            return;
        }
        container.effectLayers.forEach(function (o) {
            _this.scene.removeEffectLayer(o);
            if (dispose) {
                o.dispose();
            }
        });
    };
    /**
     * Disposes the component and the associated ressources.
     */
    EffectLayerSceneComponent.prototype.dispose = function () {
        var layers = this.scene.effectLayers;
        while (layers.length) {
            layers[0].dispose();
        }
    };
    EffectLayerSceneComponent.prototype._isReadyForMesh = function (mesh, hardwareInstancedRendering) {
        var layers = this.scene.effectLayers;
        for (var _i = 0, layers_3 = layers; _i < layers_3.length; _i++) {
            var layer = layers_3[_i];
            if (!layer.hasMesh(mesh)) {
                continue;
            }
            for (var _a = 0, _b = mesh.subMeshes; _a < _b.length; _a++) {
                var subMesh = _b[_a];
                if (!layer.isReady(subMesh, hardwareInstancedRendering)) {
                    return false;
                }
            }
        }
        return true;
    };
    EffectLayerSceneComponent.prototype._renderMainTexture = function (camera) {
        this._renderEffects = false;
        this._needStencil = false;
        var needRebind = false;
        var layers = this.scene.effectLayers;
        if (layers && layers.length > 0) {
            this._previousStencilState = this._engine.getStencilBuffer();
            for (var _i = 0, layers_4 = layers; _i < layers_4.length; _i++) {
                var effectLayer = layers_4[_i];
                if (effectLayer.shouldRender() &&
                    (!effectLayer.camera ||
                        (effectLayer.camera.cameraRigMode === Camera.RIG_MODE_NONE && camera === effectLayer.camera) ||
                        (effectLayer.camera.cameraRigMode !== Camera.RIG_MODE_NONE && effectLayer.camera._rigCameras.indexOf(camera) > -1))) {
                    this._renderEffects = true;
                    this._needStencil = this._needStencil || effectLayer.needStencil();
                    var renderTarget = effectLayer._mainTexture;
                    if (renderTarget._shouldRender()) {
                        this.scene.incrementRenderId();
                        renderTarget.render(false, false);
                        needRebind = true;
                    }
                }
            }
            this.scene.incrementRenderId();
        }
        return needRebind;
    };
    EffectLayerSceneComponent.prototype._setStencil = function () {
        // Activate effect Layer stencil
        if (this._needStencil) {
            this._engine.setStencilBuffer(true);
        }
    };
    EffectLayerSceneComponent.prototype._setStencilBack = function () {
        // Restore effect Layer stencil
        if (this._needStencil) {
            this._engine.setStencilBuffer(this._previousStencilState);
        }
    };
    EffectLayerSceneComponent.prototype._draw = function (renderingGroupId) {
        if (this._renderEffects) {
            this._engine.setDepthBuffer(false);
            var layers = this.scene.effectLayers;
            for (var i = 0; i < layers.length; i++) {
                var effectLayer = layers[i];
                if (effectLayer.renderingGroupId === renderingGroupId) {
                    if (effectLayer.shouldRender()) {
                        effectLayer.render();
                    }
                }
            }
            this._engine.setDepthBuffer(true);
        }
    };
    EffectLayerSceneComponent.prototype._drawCamera = function () {
        if (this._renderEffects) {
            this._draw(-1);
        }
    };
    EffectLayerSceneComponent.prototype._drawRenderingGroup = function (index) {
        if (!this.scene._isInIntermediateRendering() && this._renderEffects) {
            this._draw(index);
        }
    };
    return EffectLayerSceneComponent;
}());
export { EffectLayerSceneComponent };
EffectLayer._SceneComponentInitialization = function (scene) {
    var component = scene._getComponent(SceneComponentConstants.NAME_EFFECTLAYER);
    if (!component) {
        component = new EffectLayerSceneComponent(scene);
        scene._addComponent(component);
    }
};
//# sourceMappingURL=effectLayerSceneComponent.js.map